// בדיקות מקובצות: שגיאות / אזהרות (עם אישור מתועד) / מידע ובדיקות שעברו.
import type { Check } from '../editor/types';

interface Props {
  checks: Check[];
  /** אם מועבר — אזהרות מוצגות עם תיבת אישור */
  acks?: string[];
  onAck?: (code: string, on: boolean) => void;
}

export default function ChecksView({ checks, acks, onAck }: Props) {
  const errors = checks.filter((c) => !c.passed && c.severity === 'error');
  const warns = checks.filter((c) => !c.passed && c.severity === 'warning');
  const info = checks.filter((c) => c.passed || c.severity === 'info');
  return (
    <div className="xc-checks">
      <section aria-label="שגיאות">
        <h4 className="ed-h" style={{ color: 'var(--danger)' }}>שגיאות ({errors.length})</h4>
        {errors.length === 0 ? <div className="small muted">אין</div> : (
          <ul>{errors.map((c, i) => <li key={c.code + i}>⛔ {c.message} <span className="mono muted">{c.code}</span></li>)}</ul>
        )}
      </section>
      <section aria-label="אזהרות">
        <h4 className="ed-h" style={{ color: 'var(--warn)' }}>אזהרות ({warns.length})</h4>
        {warns.length === 0 ? <div className="small muted">אין</div> : (
          <ul>{warns.map((c, i) => (
            <li key={c.code + i}>
              {onAck ? (
                <label className="chk" style={{ alignItems: 'flex-start' }}>
                  <input type="checkbox" checked={acks?.includes(c.code) ?? false} onChange={(e) => onAck(c.code, e.target.checked)} />
                  <span>⚠ {c.message} <span className="mono muted">{c.code}</span><br /><span className="muted">אני מאשר/ת את האזהרה (יתועד ביצוא)</span></span>
                </label>
              ) : <>⚠ {c.message} <span className="mono muted">{c.code}</span></>}
            </li>
          ))}</ul>
        )}
      </section>
      <section aria-label="מידע ובדיקות שעברו">
        <h4 className="ed-h" style={{ color: 'var(--ok)' }}>עברו / מידע ({info.length})</h4>
        <details><summary className="small">הצג</summary>
          <ul>{info.map((c, i) => <li key={c.code + i}>{c.passed ? '✓' : 'ℹ'} {c.message} <span className="mono muted">{c.code}</span></li>)}</ul>
        </details>
      </section>
    </div>
  );
}
